export const STORY_MODE_BONUS_TIME_FRAME = 14 * 24 * 60 * 60; // 14 days
export const STORY_MODE_CHAPTER_COUNT = 7;
export const STORY_MODE_MISSIONS_PER_CHAPTER = 5;
export const STORY_MODE_TOTAL_MISSIONS =
  STORY_MODE_CHAPTER_COUNT * STORY_MODE_MISSIONS_PER_CHAPTER;

export const HEALTH_ITEM_PRICE = 4100;

export const isStoryModeComplete = (
  currentStage: number,
  completedAt: number[] = []
) =>
  currentStage >= STORY_MODE_CHAPTER_COUNT ||
  (completedAt[STORY_MODE_CHAPTER_COUNT - 1] ?? 0) > 0;

export const getStoryModeElapsedEnd = (
  currentStage: number,
  completedAt: number[] = [],
  currentTime: number
) => {
  if (!isStoryModeComplete(currentStage, completedAt)) {
    return currentTime;
  }

  return (
    completedAt[STORY_MODE_CHAPTER_COUNT - 1] ||
    Math.max(0, ...completedAt) ||
    currentTime
  );
};